// extracted by mini-css-extract-plugin
export var danger = "_3e-6";
export var lightPink = "_3e-a";
export var medium = "_3e-j";
export var nearSquare = "_3e-m";
export var neutralBlue = "_3e-8";
export var neutralYellow = "_3e-7";
export var noCapitalize = "_3e-1";
export var normal = "_3e-2";
export var pill = "_3e-0";
export var primary = "_3e-3";
export var primaryLight = "_3e-4";
export var shadow = "_3e-n";
export var small = "_3e-k";
export var solidBlack = "_3e-i";
export var solidGreen = "_3e-d";
export var solidLightBlue = "_3e-f";
export var solidNavy = "_3e-e";
export var solidOrange = "_3e-h";
export var solidPink = "_3e-g";
export var solidRed = "_3e-b";
export var solidWhite = "_3e-9";
export var solidYellow = "_3e-c";
export var success = "_3e-5";
export var xsmall = "_3e-l";